<template>
  <div
    v-if="listingSearch && listingSearch.cancelled"
    class="listing-search-empty-state mt-5"
    role="status"
  >
    <p class="is-bolder">
      Busca cancelada
    </p>
    <p>Ajuste os filtros e clique em Buscar.</p>
  </div>
</template>

<script>
import { LISTING_SEARCH } from '@/composables/useListingSearch';

export default {
  name: 'ListingSearchEmptyState',
  inject: {
    listingSearch: { from: LISTING_SEARCH, default: null },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/src/_textVariables.scss';

.listing-search-empty-state {
  text-align: center;
}
</style>
